module.exports = __webpack_public_path__ + "static/media/micro-1.9d38b0ba.svg";